export default __webpack_public_path__ + "12cb87ae4886d0b5124c5691aa423f92.png";